const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCcXsX(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gprrmm60ea"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 1783",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#gprrmm60ea)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1482",
    d: "M20.667 21.667h-16A2.669 2.669 0 0 1 2 19V9.667A2.669 2.669 0 0 1 4.667 7h16a2.669 2.669 0 0 1 2.667 2.667V19a2.669 2.669 0 0 1-2.667 2.667m-16-13.333a1.335 1.335 0 0 0-1.334 1.333V19a1.335 1.335 0 0 0 1.333 1.333h16A1.335 1.335 0 0 0 22 19V9.667a1.335 1.335 0 0 0-1.333-1.333z",
    transform: "translate(-.667 -2.333)",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1483",
    d: "M14.023 20.079a4.508 4.508 0 0 1-2.031.4 3.394 3.394 0 0 1-2.546-.979 3.559 3.559 0 0 1-.95-2.6 3.808 3.808 0 0 1 1.059-2.781 3.645 3.645 0 0 1 2.72-1.081 4.765 4.765 0 0 1 1.748.279v1.357a3.258 3.258 0 0 0-1.66-.424 2.266 2.266 0 0 0-1.745.708 2.6 2.6 0 0 0-.657 1.845 2.512 2.512 0 0 0 .625 1.787 2.169 2.169 0 0 0 1.665.669 3.409 3.409 0 0 0 1.773-.469z",
    transform: "translate(-2.832 -4.347)",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1484",
    d: "M24.177 20.079a4.508 4.508 0 0 1-2.031.4A3.394 3.394 0 0 1 19.6 19.5a3.559 3.559 0 0 1-.95-2.6 3.808 3.808 0 0 1 1.059-2.781 3.645 3.645 0 0 1 2.72-1.081 4.765 4.765 0 0 1 1.748.279v1.357a3.258 3.258 0 0 0-1.66-.424 2.266 2.266 0 0 0-1.745.708 2.6 2.6 0 0 0-.657 1.845 2.512 2.512 0 0 0 .625 1.787 2.169 2.169 0 0 0 1.665.669 3.409 3.409 0 0 0 1.773-.469z",
    transform: "translate(-6.217 -4.347)",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 639",
    transform: "translate(3.834 3.667)",
    style: {
      stroke: "#ff3e72",
      strokeLinecap: "round",
      strokeWidth: 2,
      fill: "none"
    },
    d: "M16.332 0 0 16.333"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCcXsX);
export default __webpack_public_path__ + "static/media/icon-cc-xs-x.08cbbb2a6ea08097a2854b01b8e7d8c4.svg";
export { ForwardRef as ReactComponent };